import {Module} from "const/Module"

export default {
  [Module.dashboard]: "Dashboard",
  [Module.company]: 'Bedrijf',
  [Module.person]: 'Persoon',
  [Module.invoice]: 'Factuur',
  [Module.product]: 'Product',

  [Module.user]: 'Mijn account',
  [Module.userMyAccount]: 'Mijn account',

  [Module.client]: 'Bedrijfsgegevens',
  [Module.clientMyAccount]: 'Bedrijfsgegevens',

  [Module.system]: 'Systeem instellingen',
  [Module.systemSettings]: 'Systeem instellingen',

  [Module.invoiceDefaultSettings]: 'invoiceDefaultSettings',
  [Module.invoiceNumberSettings]: 'invoiceNumberSettings',
  [Module.invoicePrintTemplateSettings]: 'invoicePrintTemplateSettings',

  [Module.layout]: 'Indeling',

  [Module.imapSync]: 'imapSync',

  [Module.addressType]: 'addressType',
  [Module.phoneNumberType]: 'phoneNumberType',
  [Module.emailAddressType]: 'emailAddressType',

  [Module.address]: 'address',
  [Module.bankAccount]: 'bankAccount',
  [Module.businessNumbers]: 'businessNumbers',
  [Module.companyContactPerson]: 'companyContactPerson',
  [Module.companyRelationCompany]: 'companyRelationCompany',
  [Module.dossier]: 'dossier',
  [Module.dossierNote]: 'dossierNote',
  [Module.emailAddress]: 'emailAddress',
  [Module.personNumbers]: 'personNumbers',
  [Module.phoneNumber]: 'phoneNumber',
}
